import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearLoader from "../../../Loader/LinearLoader";
import { numberDecimal } from "../../../../../utils/numberFormats";
import { useTranslationApp } from "../../../../../lib/i18next";
import { AUDIENCE_BY_BRAND_AFFINITY } from "../../../../../locales/keysTranslations";

const InfluencerAudienceBrands = ({ data = [] }) => {
  const { t } = useTranslationApp();
  if (data.length === 0) return null;

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {t(AUDIENCE_BY_BRAND_AFFINITY)}
      </Typography>
      {data.map((brand, index) => {
        if (index < 10) {
          return (
            <LinearLoader
              label={brand.name}
              value={numberDecimal(brand.value)}
              key={brand.name}
            />
          );
        }
        return null;
      })}
    </Box>
  );
};

export default InfluencerAudienceBrands;
